var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verificationCodeBtn active tapActive",class:{ disabled: _vm.verificationCodeInfo.disabled },domProps:{"textContent":_vm._s(_vm.btnText)},on:{"click":_vm.btnEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }